import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center gap-3 flex-wrap" }
const _hoisted_2 = { class: "text-lg text-left text-textPrimary font-bold" }
const _hoisted_3 = {
  key: 1,
  class: "text-xs font-mono bg-[#E2E2E9] px-2 py-0.5 rounded"
}
const _hoisted_4 = { class: "flex justify-end gap-2" }

import { computed, ref, watch } from 'vue'
import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import CheckVerificationPanel from './CheckVerificationPanel.vue'
import type { CheckVerificationContext } from './CheckVerificationPanel.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckVerificationModal',
  props: {
    isOpen: { type: Boolean },
    checkId: {}
  },
  emits: ["update:isOpen"],
  setup(__props: any, { emit }) {

const props = __props;




const context = ref<CheckVerificationContext | null>(null)

const title = computed(() => context.value?.title ?? 'Verificação do registro')

// Fechar ou trocar de check zera o cabeçalho: sem isso o chip de cobertura do
// check anterior apareceria por um instante na próxima abertura.
watch(
  () => [props.isOpen, props.checkId],
  () => {
    context.value = null
  }
)

function openMaps() {
  const url = context.value?.mapsUrl
  if (url) window.open(url, '_blank', 'noopener,noreferrer')
}

function close() {
  emit('update:isOpen', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.isOpen,
    "has-header-border": true,
    "has-footer-border": true,
    "max-width": "max-w-3xl",
    "max-height": "90vh",
    "data-testid": "check-verification-modal",
    onClose: close
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(title.value), 1),
        (context.value)
          ? (_openBlock(), _createBlock(LabelBadge, {
              key: 0,
              label: context.value.coverageLabel,
              color: context.value.coverageColor,
              size: "small",
              icon: null,
              "data-testid": "verification-coverage-chip"
            }, null, 8, ["label", "color"]))
          : _createCommentVNode("", true),
        (_ctx.checkId)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "#" + _toDisplayString(_ctx.checkId), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        (context.value?.mapsUrl)
          ? (_openBlock(), _createBlock(OutlineButton, {
              key: 0,
              text: "Abrir no Google Maps ↗",
              width: "auto",
              height: "32px",
              onClick: openMaps
            }))
          : _createCommentVNode("", true),
        _createVNode(OutlineButton, {
          text: "Fechar",
          width: "100px",
          height: "32px",
          "data-testid": "verification-close-button",
          onClick: close
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(CheckVerificationPanel, {
        "check-id": _ctx.checkId,
        onLoaded: _cache[0] || (_cache[0] = ($event: any) => (context.value = $event)),
        onFailed: _cache[1] || (_cache[1] = ($event: any) => (context.value = null))
      }, null, 8, ["check-id"])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})